var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassPlusSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,208c0,45.9-14.9,88.3-40,122.7l126.6,126.7c12.5,12.5,12.5,32.8,0,45.3c-12.5,12.5-32.8,12.5-45.3,0 L330.7,376c-34.4,25.2-76.8,40-122.7,40C93.1,416,0,322.9,0,208S93.1,0,208,0S416,93.1,416,208z M184,296c0,13.3,10.7,24,24,24 s24-10.7,24-24v-64h64c13.3,0,24-10.7,24-24s-10.7-24-24-24h-64v-64c0-13.3-10.7-24-24-24s-24,10.7-24,24v64h-64 c-13.3,0-24,10.7-24,24s10.7,24,24,24h64V296z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassPlusSolid);
export default __webpack_public_path__ + "static/media/magnifying-glass-plus-solid.4881f29f7de8555ba5d77b222cec056f.svg";
export { ForwardRef as ReactComponent };